module.exports = __webpack_public_path__ + "img/ANTENNA FLOWER LIME.e3d448d.svg";